import { render, staticRenderFns } from "./updated-agreements-2026-announcement.vue?vue&type=template&id=79107955&scoped=true&"
import script from "./updated-agreements-2026-announcement.vue?vue&type=script&lang=js&"
export * from "./updated-agreements-2026-announcement.vue?vue&type=script&lang=js&"
import style0 from "./updated-agreements-2026-announcement.vue?vue&type=style&index=0&id=79107955&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79107955",
  null
  
)

export default component.exports